import { Badge, Box, HStack, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { useDraggable } from '@dnd-kit/core'
import { loadColor } from './lobbyScheduleUtils'
import type { ScheduleAttendeeDto } from '../../../types/lobbyDay'

interface AttendeePoolCardProps {
  attendee: ScheduleAttendeeDto
  count: number
  /** Dim this card when a *different* pool attendee is being dragged. */
  dimmed?: boolean
  /** Tint this card green when it's the hover-linked constituent of a hovered legislator. */
  highlighted?: boolean
}

export function AttendeePoolCard({ attendee, count, dimmed, highlighted }: AttendeePoolCardProps) {
  const hasDistrict = !!(attendee.stateHouseDistrict || attendee.stateSenateDistrict)
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `pool-${attendee.attendeeId}`,
    data: { type: 'pool-attendee', attendeeId: attendee.attendeeId },
  })
  return (
    <Box
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      cursor="grab"
      opacity={isDragging ? 0.4 : dimmed ? 0.45 : 1}
      bg={highlighted ? 'green.50' : 'white'}
      borderWidth="1px"
      borderColor={highlighted ? 'green.400' : 'gray.200'}
      borderRadius="md"
      p={2}
      mb={2}
    >
      <HStack justify="space-between" gap={2}>
        <Text fontSize="sm" fontWeight="medium" lineClamp={1}>{attendee.fullName}</Text>
        <Badge colorPalette={loadColor(count)}>{count}</Badge>
      </HStack>
      <Wrap gap={1} mt={1}>
        {attendee.hasVoterRecord && hasDistrict ? (
          <>
            {attendee.stateHouseDistrict && (
              <WrapItem><Badge fontSize="0.6rem" variant="subtle">HD-{attendee.stateHouseDistrict}</Badge></WrapItem>
            )}
            {attendee.stateSenateDistrict && (
              <WrapItem><Badge fontSize="0.6rem" variant="subtle">SD-{attendee.stateSenateDistrict}</Badge></WrapItem>
            )}
          </>
        ) : (
          <WrapItem><Badge fontSize="0.6rem" colorPalette="yellow">district unknown</Badge></WrapItem>
        )}
      </Wrap>
    </Box>
  );
}
